import { Navigate } from "react-router-dom";
import { Radio } from "lucide-react";
import { useViewerAuth } from "@/context/ViewerAuthContext";
import { YSVCHI_PRICING_URL } from "@/lib/ysvAuthApi";

const CenteredShell = ({ children }) => (
  <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A] px-6 py-16 text-white">
    {children}
  </div>
);

export function ViewerGate({ children }) {
  const { user, loading, canWatch, logout, freeAccess, configLoading } = useViewerAuth();

  if (loading || configLoading) {
    return (
      <CenteredShell>
        <p className="font-display text-sm font-bold uppercase tracking-[0.25em] text-white/40">
          Checking access…
        </p>
      </CenteredShell>
    );
  }

  // Temporary free-access window: content is open to everyone.
  if (freeAccess) return children;

  if (!user) return <Navigate to="/sign-in" replace />;

  if (!canWatch) {
    return (
      <CenteredShell>
        <div className="w-full max-w-lg border border-white/10 bg-[#141414] p-8 text-center md:p-10">
          <span className="mx-auto flex h-14 w-14 items-center justify-center bg-[#007AFF]">
            <Radio className="h-7 w-7" />
          </span>
          <p className="mt-6 font-display text-xs font-bold uppercase tracking-[0.25em] text-[#007AFF]">
            Subscription Required
          </p>
          <h1 className="mt-3 font-display text-3xl font-black uppercase tracking-tight md:text-4xl">
            Choose Fan or Member to watch
          </h1>
          <p className="mx-auto mt-4 max-w-md leading-relaxed text-white/55">
            Your YSV account is active, but it does not have a viewing subscription yet.
            Subscribe securely on YSVCHI, then return here and sign in again.
          </p>
          <div className="mt-8 grid gap-3 sm:grid-cols-2">
            <a
              href={YSVCHI_PRICING_URL}
              data-testid="subscribe-on-ysvchi"
              className="bg-[#007AFF] px-5 py-3.5 font-display text-sm font-bold uppercase tracking-widest text-white transition-colors hover:bg-[#0062cc]"
            >
              Subscribe on YSVCHI
            </a>
            <button
              type="button"
              data-testid="subscription-sign-out"
              onClick={logout}
              className="border border-white/20 px-5 py-3.5 font-display text-sm font-bold uppercase tracking-widest text-white transition-colors hover:border-white/50"
            >
              Sign Out
            </button>
          </div>
        </div>
      </CenteredShell>
    );
  }

  return children;
}
